import { createApp, defineAsyncComponent } from "vue";

import SvgVue from 'svg-vue3'
import VueLazyLoad from 'vue3-lazyload'

const app = createApp({
  components: {
    VideoBackground: defineAsyncComponent(() => import('./common/VideoBackground.vue')),
    Slider: defineAsyncComponent(() => import('./common/Slider.vue')),
    SocialIcons: defineAsyncComponent(() => import('./common/SocialMediaIcons.vue')),
  },

  data: () => ({
    openMenu: '',
    alertsOpen: false,
    scrollPosition: 0,
    activeMobileNavGroup: 'about',
    isLeaving: '',
    lastEvent: undefined,
    remind_me: true,
    rememberedLinks: []
  }),

  computed: {
    mobileMenu () {
      return this.openMenu === 'mobileMenu'
    },
    howDoI () {
      return this.openMenu === 'howDoI'
    },
    searchBox () {
      return this.openMenu === 'searchBox'
    },
    isScrolling () {
      return this.scrollPosition > 0
    },
  },

  mounted () {
    if (localStorage.popup === true || !('popup' in localStorage)) {
      this.popupOpen = true
    } else {
      this.popupOpen = false
    }

    if (!localStorage.outboundLinks) {
      localStorage.outboundLinks = JSON.stringify([])
    }
    this.rememberedLinks = JSON.parse(localStorage.getItem('outboundLinks'))
  },


  methods: {
    toggleMenu (menu = '') {
      if(this.openMenu != menu) {
        this.openMenu = menu
        this.$nextTick(() => {
          this.$refs[menu + '_modal'].focus()
        })
      } else {
        this.openMenu = ''
        this.$nextTick(() => {
          this.$refs[menu + '_button'].focus()
        })
      }
    },

    setMobileNavGroup (item) {
      this.activeMobileNavGroup = this.activeMobileNavGroup != item ? item : ''
    },

    handleScroll (event) {
      this.scrollPosition = window.pageYOffset != undefined ? window.pageYOffset : window.scrollY
    },

    toggleFaq(val){
      this.activeFaq = this.activeFaq == val ? '' : val
    },

  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

})

app.use(VueLazyLoad, {
  loading: '/images/blank.svg',
  error: '/images/blank.svg',
  lifecycle:{
    loading: (el) => {
      el.lazy = 'loading'
    },
    error: (el) => {
      el.lazy = 'error'
    },
    loaded: (el) => {
      el.lazy = 'loaded'
    }
  }
})

app.use(SvgVue, {
  svgPath: 'resources/svg',
  extract: false,
  svgoSettings: [
      { removeTitle: true },
      { removeViewBox: false },
      { removeDimensions: true }
  ]
})

app.mount("#app")
